export default () => {
  if (window['performance'] && window['performance']['now']) return window['performance']['now']();
  return +(new Date());
}



// WEBPACK FOOTER //
// ./src/utils/now.js